const getParcelTrackingStyles = theme => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.mediaQuery('tablet')]: {
    gap: 0,
    flexDirection: 'row'
  }
});
const getParcelTrackingAsideStyles = theme => ({
  flex: '0 0 auto',
  [theme.mediaQuery('tablet')]: {
    width: theme.spacing(20),
    marginRight: theme.spacing(4)
  }
});
const getParcelTrackingContentStyles = {
  flex: '1 1 auto'
};
const getParcelTrackingDetailsSummaryStyles = {
  '::-webkit-details-marker': {
    display: 'none'
  },
  '::marker': {
    display: 'none',
    content: "''"
  }
};
const getParcelTrackingDetailsSummaryWrapperStyles = {
  width: '100%',
  display: 'flex',
  justifyContent: 'space-between'
};
const getParcelTrackingTimelineWrapperStyles = theme => ({
  display: 'grid',
  gap: theme.spacing(7),
  marginTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  [theme.mediaQuery('tablet')]: {
    marginTop: theme.spacing(5),
    gridTemplateColumns: `auto ${theme.spacing(25)}px`
  }
});

export { getParcelTrackingAsideStyles, getParcelTrackingContentStyles, getParcelTrackingDetailsSummaryStyles, getParcelTrackingDetailsSummaryWrapperStyles, getParcelTrackingStyles, getParcelTrackingTimelineWrapperStyles };
//# sourceMappingURL=ParcelTrackingStyles.js.map
